import { ShiftsScreen } from './ShiftsScreen.jsx';

export default {
  path: '/shifts',
  element: <ShiftsScreen />,
  protected: true,
  permission: null,
  // الكاشير يرى شفتاته فقط (يفرضه الخادم)، والمدير يرى الجميع.
  anyPermission: [
    'shifts.view', 'shifts.manage',
    'checkout.settle', 'reception.create_session', 'reception.issue_card',
    'pos.cafeteria.sell', 'pos.toys.sell'
  ],
  standalone: false,
  sidebar: { label: 'الشفتات', icon: 'clock', group: 'finance', order: 78 }
};
